module.exports = __webpack_public_path__ + "tripadvisor-fav-icon.png?7d7e9c254ce4baea67817d40e427248d";